/* eslint-disable */
import { Option, TranslationFunction } from '@/types';
import { i18n } from '@/main';
import { ItemLineChart } from '@/store/modules/pharmacy/types';

export const activeOptions = ($t: TranslationFunction): Option[] => [
  {
    value: 'week',
    label: $t('week')
  },
  {
    value: 'month',
    label: $t('thisMonth')
  },
  {
    value: 'fullMonth',
    label: $t('fullMonth')
  }
];

export const activeOtherPeriodOptions = ($t: TranslationFunction): Option[] => [
  {
    value: 'prevPeriod',
    label: $t('prevPeriod')
  },
  {
    value: 'average',
    label: $t('average')
  }
];

export const colorScale = [
  '#E2523F',
  '#E8633A',
  '#ED7436',
  '#F18537',
  '#F39737',
  '#F19E37',
  '#E29B49',
  '#C48F5C',
  '#A3836A',
  '#738C7B',
  '#47987F'
];

export function getLabelsMap(): any {
  const labelsMap: Record<string, unknown> = {
    GOOD: i18n.global.t('happy'),
    OK: i18n.global.t('ok'),
    BAD: i18n.global.t('angry')
  };

  return labelsMap;
}

let width: any, height: any, gradient: any;

const getGradient = (ctx: any, chartArea: any) => {
  const chartWidth = chartArea.right - chartArea.left;
  const chartHeight = chartArea.bottom - chartArea.top;
  if (!gradient || width !== chartWidth || height !== chartHeight) {
    width = chartWidth;
    height = chartHeight;
    gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
    gradient.addColorStop(0, '#E2523F');
    gradient.addColorStop(0.5, '#F19E37');
    gradient.addColorStop(1, '#47987F');
  }

  return gradient;
};

export const defaultDataLineChart = {
  labels: [],
  datasets: [
    {
      label: 'thisPeriod',
      data: [],
      backgroundColor: '#47987F',
      borderWidth: 2,
      fill: false,
      pointRadius: 3,
      tension: 0.1,
      pointBackgroundColor: function (context: any) {
        const chart = context.chart;
        const { ctx, chartArea } = chart;

        if (!chartArea) {
          return '#47987F'; // fallback, якщо chartArea ще не готовий
        }
        return getGradient(ctx, chartArea); // колір всередині точки та лінії
      },
      pointBorderColor: function (context: any) {
        const chart = context.chart;
        const { ctx, chartArea } = chart;

        if (!chartArea) {
          return '#47987F';
        }
        return getGradient(ctx, chartArea); // колір контуру точки той же, що й лінія
      },
      borderColor: function (context: any) {
        const chart = context.chart;
        const { ctx, chartArea } = chart;

        if (!chartArea) {
          return;
        }
        return getGradient(ctx, chartArea);
      }
    },
    {
      label: 'otherPeriod',
      data: [],
      backgroundColor: '#1B242D',
      borderColor: '#1B242D',
      borderDash: [5, 5],
      borderWidth: 1.5,
      fill: false,
      pointBackgroundColor: 'transparent',
      pointBorderColor: 'transparent',
      pointHoverBackgroundColor: 'transparent',
      pointHoverBorderColor: 'transparent',
      pointRadius: 0,
      tension: 0
    }
  ]
};

export const defaultDataPieChart = {
  labels: [],
  datasets: [
    {
      data: [],
      backgroundColor: ['#47987F', '#F19E37', '#E2523F'],
      borderColor: ['#47987F', '#F19E37', '#E2523F'],
      borderWidth: 0
    }
  ]
};

export const defaultDataBarChart = {
  labels: [],
  datasets: [
    {
      data: [],
      label: 'Angry',
      backgroundColor: '#E2523F',
      barPercentage: 0.8,
      borderRadius: 4,
      categoryPercentage: 0.6
    },
    {
      data: [],
      label: 'OK',
      backgroundColor: '#F19E37',
      barPercentage: 0.8,
      borderRadius: 4,
      categoryPercentage: 0.6
    },
    {
      data: [],
      label: 'Happy',
      backgroundColor: '#47987F',
      barPercentage: 0.8,
      borderRadius: 4,
      categoryPercentage: 0.6
    }
  ]
};

export const defaultDataBarChartAmount = {
  labels: [],
  datasets: {
    data: [],
    backgroundColor: [],
    barPercentage: 0.6,
    borderRadius: 4,
    categoryPercentage: 0.6,
    borderSkipped: false
  }
};

export const optionsBarChart = {
  responsive: true,
  plugins: {
    legend: {
      position: 'top',
      align: 'center',
      labels: {
        filter: (item: ItemLineChart): boolean | undefined => {
          if (item.text === i18n.global.t('happy')) {
            return item.text.includes(i18n.global.t('happy'));
          }
          if (item.text === i18n.global.t('ok')) {
            return item.text.includes(i18n.global.t('ok'));
          }
          if (item.text === i18n.global.t('angry')) {
            return item.text.includes(i18n.global.t('angry'));
          }
        },
        font: {
          family: 'Ubuntu-Regular',
          size: 13
        },
        usePointStyle: true,
        pointStyle: 'circle',
        boxHeight: 4,
        boxWidth: 4
      }
    },
    title: {
      display: true,
      text: 'General Satisfaction',
      align: 'start',
      color: '#1B242D',
      font: { family: 'Ubuntu-Regular', size: 16, weight: '600' }
    }
  },
  scales: {
    x: {
      grid: { display: false }
    },
    y: {
      beginAtZero: true,
      grid: { tickColor: '#fff' },
      type: 'linear',
      min: 0
    }
  }
};

export const optionsBarChartAmount = {
  responsive: true,
  plugins: {
    legend: {
      display: false
    },
    title: {
      display: true,
      text: 'Customers Amount',
      align: 'start',
      color: '#1B242D',
      padding: {
        bottom: 50
      },
      font: { family: 'Ubuntu-Regular', size: 16, weight: '600' }
    }
  },
  scales: {
    x: {
      grid: { display: false }
    },
    y: {
      beginAtZero: true,
      grid: { tickColor: '#fff' },
      type: 'linear',
      min: 0
    }
  }
};
